module.exports = __webpack_public_path__ + "img/shift4-bg.96c407ee.jpg";